import {
  SlSelect
} from "./chunk.AILU2HNL.js";

// src/components/select/select.ts
var select_default = SlSelect;
SlSelect.define("sl-select");

export {
  select_default
};
